import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import {
  RegistrationCitizenshipFormVM,
  CitizenshipFormVM,
} from 'mutation/view-models/registration-citizenship';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { ActType } from 'shell/constants/act-type';
import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';

export const initialValueCitizenship: CitizenshipFormVM = {
  reasonCitizenship: '',
  toDPR: {
    dateBuying: null,
    dateDPR: null,
    dateOath: null,
    paper: emptyPaper,
    digital: emptyDigital,
    actType: ActType.AttoCartaceo,
  },
  choiceItalian: {
    dateBuying: null,
    dateOath: null,
    paper: emptyPaper,
    digital: emptyDigital,
    actType: ActType.AttoCartaceo,
  },
  foreignCitizenship: {
    dateBuying: null,
    dateOath: null,
    paper: emptyPaper,
    digital: emptyDigital,
    actType: ActType.AttoCartaceo,
  },
  opeLegis: {},
  foreignNaturalization: {},
  renunciationCitizenship: {
    paper: emptyPaper,
    digital: emptyDigital,
    actType: ActType.AttoCartaceo,
  },
  doubleCitizenship: {},
  italianCitizenshipDP: {
    paper: emptyPaper,
    digital: emptyDigital,
    actType: ActType.AttoCartaceo,
  },
};

export const transformerRegistrationCitizenshipData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): RegistrationCitizenshipFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person);
  const familyCoexistence = transformFamilyCoexistence(person);

  const citizenshipArray = transformCitizenship(person);

  return {
    person: personData,
    familyCoexistence,
    editDataControl: {
      dateValidity: null,
    },
    newCitizenship: {
      ...initialValueCitizenship,
    },
    citizenship: citizenshipArray,
  };
};
